import { useState } from 'react'

import checkmarkIcon from 'assets/icons/checkmark.svg'
import { rapidDefinitions, rapidRows } from 'constants/ProjectSetUpConstants'

import { RapidFrameworkModal } from './RapidFrameworkModal'

export const MakeAssignmentsPanel = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <div className="setup-panel-surface flex gap-6 items-start w-full">
      <div className="flex flex-col items-center justify-center self-stretch rounded-[8px] border-neutral-50 bg-white px-[18px] py-[154px]">
        <div className="rapid-mini-diagram shrink-0">
          <div className="rapid-mini-badges">
            {rapidRows.map(row => (
              <div key={row.letter} className="rapid-mini-badge-cell">
                <span className="rapid-badge" style={{ backgroundColor: row.color }}>
                  {row.letter}
                </span>
              </div>
            ))}
          </div>
          <div className="rapid-mini-labels">
            {rapidRows.map(row => (
              <div key={row.letter} className="rapid-mini-label-cell" style={{ backgroundColor: row.color }}>
                <span className="subtitle-s">{row.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-between items-end flex-[1_0_0] self-stretch">
        <div className="flex flex-col gap-4 items-start w-full">
          <p className="body-l w-full">
            Consider the dynamics of your entire team and determine responsibilities and requirements for specific
            roles.
          </p>

          <div className="flex flex-col gap-2 items-start w-full">
            {rapidDefinitions.map(definition => (
              <div key={definition.bold} className="flex gap-2 items-start w-full">
                <img src={checkmarkIcon} alt="" className="necessary-roles-check" />
                <p className="body-xs flex-1">
                  {definition.prefix}
                  <span className="subtitle-xxs">{definition.bold}</span>
                  {definition.rest}
                </p>
              </div>
            ))}
          </div>
        </div>

        <button className="setup-cta-button" onClick={() => setIsModalOpen(true)}>
          Open RAPID framework
        </button>
      </div>

      <RapidFrameworkModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  )
}
